import * as React from 'react';
import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import PhoneInput, { PhoneInputProps } from '@/components/input/PhoneInput';
import TextFieldItem from '@/components/input/TextFieldItem';
import { Value } from '@/model/common';

interface PhoneItemProps {
  'data-test'?: string;
  value: Value<string>;
  onChange?: (value: string) => Promise<void> | void;
  readonly?: boolean;
  shortMask?: boolean;
  messages?: Partial<{
    label: ReactNode;
    error: ReactNode;
  }>;
}

const ShortMaskPhoneInput: React.FC<PhoneInputProps> = (props: PhoneInputProps) => <PhoneInput {...props} shortMask />;
const FullMaskPhoneInput: React.FC<PhoneInputProps> = (props: PhoneInputProps) => <PhoneInput {...props} />;

const PhoneItem: React.FC<PhoneItemProps> = ({
  value,
  onChange,
  readonly,
  shortMask,
  messages,
  'data-test': dataTest,
}) => {
  const handleChange = async (maskedPhone: string): Promise<void> => {
    if (!onChange) {
      return;
    }
    const phone = maskedPhone
      .replace(/[^\d]/g, '') // exclude all non digits
      .substring(1); // exclude code
    if ((value?.value || '') !== (phone || '')) {
      await onChange(phone);
    }
  };
  return (
    <TextFieldItem
      data-test={dataTest}
      inputComponent={shortMask ? ShortMaskPhoneInput : FullMaskPhoneInput}
      InputProps={{ className: 'ym-hide-content' }}
      onChange={handleChange}
      value={value}
      readonly={readonly}
      messages={{
        label: messages?.label,
        error: messages?.error || <FormattedMessage id="common.components.phone.invalid" />,
      }}
    />
  );
};

export default PhoneItem;
